var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pl-0",
      staticStyle: { "max-height": "200px", overflow: "auto" },
      attrs: { flat: "" }
    },
    [
      _c(
        "v-layout",
        { staticClass: "pl-0", attrs: { rows: "" } },
        [
          _c(
            "v-navigation-drawer",
            {
              staticClass: "custom-drawer",
              attrs: {
                "mini-variant": _vm.drawer.mini,
                "mini-variant-width": "120",
                "mobile-break-point": "1",
                floating: ""
              },
              model: {
                value: _vm.drawer.open,
                callback: function($$v) {
                  _vm.$set(_vm.drawer, "open", $$v)
                },
                expression: "drawer.open"
              }
            },
            [
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      staticClass: "cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.drawer.mini = false
                        }
                      }
                    },
                    [
                      _c("v-list-tile-action", [
                        _c("img", {
                          staticClass: "align-center",
                          attrs: { height: "20", src: "/static/ltn-l.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(_vm._s(_vm.$t("site-title")) + " Profile")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm.isStockyard
                    ? _c(
                        "v-list-tile",
                        {
                          staticClass: "cursor-pointer",
                          on: {
                            click: function($event) {
                              return _vm.toggleProfileData("showLoadChuteInfo")
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("directions")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-content", [
                            _vm._v(_vm._s(_vm.$t("company-profile.load-chute")))
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.company
                    ? _c(
                        "v-list-tile",
                        {
                          staticClass: "cursor-pointer hidden-sm-and-down",
                          on: {
                            click: function($event) {
                              return _vm.toggleProfileData(
                                "showLoadContactInfo"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("account_box")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-content", [_vm._v("Load Contacts")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.viewProfile
                    ? _c(
                        "v-list-tile",
                        {
                          staticClass: "cursor-pointer",
                          on: {
                            click: function($event) {
                              return _vm.toggleProfileData(
                                "showCompanyContactInfo"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("store")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v("Company Contact")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canViewCarrierDocumentation
                    ? _c(
                        "v-list-tile",
                        {
                          staticClass: "cursor-pointer hidden-sm-and-down",
                          on: {
                            click: function($event) {
                              return _vm.toggleProfileData(
                                "showCarrierDocumentation"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("attach_file")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-content", [_vm._v("Documentation")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _vm.showCompanyContactInfo
                ? _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("v-flex", [
                        _c("b", [_vm._v("Email:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._.get(
                                _vm.viewProfile,
                                "contactEmail",
                                "not provided"
                              )
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-flex", [
                        _c("b", [_vm._v("Phone:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._.get(
                                _vm.viewProfile,
                                "contactPhone",
                                "not provided"
                              )
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-flex", [
                        _c("b", [_vm._v("Contact Name:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._.get(
                                _vm.viewProfile,
                                "contactName",
                                "not provided"
                              )
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c("b", [_vm._v("Billing Address:")]),
                          _vm._v(" "),
                          _vm._.get(
                            _vm.viewProfile,
                            "producerInfo.billingAddress",
                            false
                          )
                            ? [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._.get(
                                        _vm.viewProfile,
                                        "producerInfo.billingAddress.street1",
                                        ""
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._.get(
                                  _vm.viewProfile,
                                  "producerInfo.street2",
                                  false
                                )
                                  ? _c("div", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm._.get(
                                              _vm.viewProfile,
                                              "producerInfo.billingAddress.street2",
                                              ""
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.viewProfile,
                                          "producerInfo.billingAddress.city",
                                          ""
                                        )
                                      ) +
                                      "\n              " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.viewProfile,
                                          "producerInfo.billingAddress.region",
                                          ""
                                        )
                                      ) +
                                      "\n              " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.viewProfile,
                                          "producerInfo.billingAddress.postalCode",
                                          ""
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ]
                            : _c("span", [_vm._v("not provided")])
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showLoadContactInfo && _vm.company
                ? _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _vm._l(_vm.company.contacts, function(contact, cInx) {
                        return _c(
                          "v-flex",
                          { key: cInx },
                          [
                            _c("label", [_vm._v(_vm._s(contact.name))]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("v-icon", [_vm._v("local_phone")]),
                            _vm._v(" "),
                            contact.phone
                              ? _c("span", [_vm._v(_vm._s(contact.phone))])
                              : _c("span", [_vm._v("Missing")]),
                            _vm._v(" "),
                            contact.nightContactName
                              ? _c("v-template", [
                                  _c("label", [
                                    _vm._v(_vm._s(contact.nightContactName))
                                  ]),
                                  _vm._v(" "),
                                  contact.nightContactPhone
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(contact.nightContactPhone)
                                        )
                                      ])
                                    : _c("span", [_vm._v("Missing")])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.isStockyard
                        ? _c("v-flex", [
                            _c(
                              "label",
                              [
                                _c("v-icon", [_vm._v("local_phone")]),
                                _vm._v(" " + _vm._s(_vm.loadingChute.label))
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("label", [_c("b", [_vm._v("Day time:")])]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.loadingChute.daytimePhone))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("label", [_c("b", [_vm._v("Night time:")])]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.loadingChute.nightTimePhone))
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldShowCarrierDocumentation
                ? _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "company-profile.vendor-tax-document"
                                    )
                                  ) + ":"
                                )
                              ]),
                              _vm._v(" "),
                              _vm.truckingInfo.w9Url
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "pl-0",
                                      attrs: { flat: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.openFile(
                                            _vm.truckingInfo.w9Url
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm
                                              .$t(
                                                "company-profile.vendor-tax-document"
                                              )
                                              .toLocaleLowerCase()
                                          ) +
                                          ".pdf\n            "
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("Missing")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _c("b", [_vm._v("Insurance Policy:")]),
                              _vm._v(" "),
                              _vm.truckingInfo.insurancePolicyUrl
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "pl-0",
                                      attrs: { flat: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.openFile(
                                            _vm.truckingInfo.insurancePolicyUrl
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Insurance Policy.pdf\n            "
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("Missing")])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._.get(_vm.profile, "ein", false)
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "pb-3",
                              attrs: {
                                md6: "",
                                lg6: "",
                                xs6: "",
                                "order-xs3": ""
                              }
                            },
                            [
                              _c("b", [_vm._v("EIN:")]),
                              _vm._v(
                                " " + _vm._s(_vm.profile.ein) + "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldShowLoadChuteInfo
                ? _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("div", [
                        _vm._.get(_vm.loadingPlace, "placeName")
                          ? _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm._.get(_vm.loadingPlace, "placeName")
                                ) + ":"
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._.get(_vm.loadingPlace, "formattedAddress")
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [_vm._v("Timezone:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm._.get(_vm.loadingPlace, "timezone")) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [_vm._v("Local Time:")]),
                        _vm._v(
                          " " + _vm._s(_vm.locationLocalTime) + "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.loadingChute
                        ? _c("v-layout", { attrs: { column: "" } }, [
                            _c("div", [
                              _c("b", [
                                _vm._v(
                                  "Company instructions for " +
                                    _vm._s(
                                      _vm.$t("company-profile.load-chute")
                                    ) +
                                    " "
                                )
                              ]),
                              _vm._v(" "),
                              _vm._.get(_vm.loadingChute, "label")
                                ? _c("span", [
                                    _vm._v(
                                      "\n           (" +
                                        _vm._s(_vm.loadingChute.label) +
                                        ")\n          "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(":\n          ")
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm.loadingChute
                                ? _c("span", { staticClass: "font-italic" }, [
                                    _vm._v(
                                      _vm._s(_vm.loadingChute.instructions)
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-298a0868", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298a0868","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyProfileCard.vue
// module id = null
// module chunks = 